import { render, staticRenderFns } from "./StudentSetting.vue?vue&type=template&id=03c032f7&scoped=true"
import script from "./StudentSetting.vue?vue&type=script&lang=js"
export * from "./StudentSetting.vue?vue&type=script&lang=js"
import style0 from "./StudentSetting.vue?vue&type=style&index=0&id=03c032f7&prod&scoped=true&lang=css"
import style1 from "./StudentSetting.vue?vue&type=style&index=1&id=03c032f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c032f7",
  null
  
)

export default component.exports